import request from '@/utils/request'

/**
 * 待审批的公司流程数量、项目流程数量
 */
export function todoProcessCount() {
  return request({
    url: '/homePage/todoProcessCount',
    method: 'post'
  })
}

/**
 * 获取逾期提醒
 * @param {Number} pageNum 页码
 * @param {Number} pageSize 分页大小
 * @param {Number} companyId 公司Id
 */
export function overDue(pageNum, pageSize, companyId) {
  return request({
    url: '/homePage/overDue',
    method: 'post',
    data: { pageNum, pageSize, companyId }
  })
}

/**
 * 公司技术领域占比
 */
export function percentageOfCompanyTechnologyArea(companyId) {
  return request({
    url: '/homePage/percentageOfCompanyTechnologyArea',
    method: 'post',
    data: { companyId }
  })
}

/**
 * 获取所属技术领域
 */
export function selectTechnicalArea(companyId) {
  return request({
    url: '/homePage/selectTechnicalArea',
    method: 'post',
    data: { companyId }
  })
}

/**
 * 项目阶段占比
 */
export function percentageOfProjectPhases(technicalArea, companyId) {
  return request({
    url: '/homePage/percentageOfProjectPhases',
    method: 'post',
    data: { technicalArea, companyId }
  })
}

/** 专利前10国家 */
export function patentsInTopTenCountries(companyId) {
  return request({
    url: '/homePage/patentsInTopTenCountries',
    method: 'post',
    data: { companyId }
  })
}

/**
 * 判断是大公司还是小公司管理员
 * userType: 0-非公司管理员,1-大公司管理员,2-小公司管理员
 */
export function smallOrBigCompanyManager(companyId) {
  return request({
    url: '/homePage/smallOrBigCompanyManager',
    method: 'post',
    data: { companyId }
  })
}

/**
 * 项目阶段状态
 */
export function projectPhaseStatus(companyId) {
  return request({
    url: '/homePage/projectPhaseStatus',
    method: 'post',
    data: { companyId }
  })
}

/**
 * 专利状态数量
 */
export function patentStatusCount() {
  return request({
    url: '/homePage/patentStatusCount',
    method: 'post'
  })
}

/**
 * 导出pdf
 * @param {提交数据} data
 */
export function getPDF(data) {
  return request({
    url: '/homePage/getPDF',
    method: 'post',
    data: data
  })
}

/**
 * 专利管理员 公司列表
 */
export function getCompany() {
  return request({
    url: '/homePage/getCompany',
    method: 'post'
  })
}
